// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

import { GridModule } from "@features/grid";
import { BbCardModule } from "@features/bb-card";
import { PlayersGridComponent } from "./players-grid.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { PlayerRoutingModule } from "./player-routing.module";
import { FilterModule } from "@features/filter";
import { EditPlayerComponent } from "./edit-player.component";
import { PlayerSharedModule } from "./player-shared.module";
import { CreateSelfRegisterPlayerFormComponent } from "./create-self-register-player-form.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { SelfRegisterPlayerComponent } from "./self-register-player.component";
import { EditPlayerTabsComponent } from "./edit-player-tabs.component";
import { BbFormIOModule } from "@features/bb-formio/bb-formio.module";
import { FormEventsService } from "@main/formio/services/formEvents.service";
import { NhsLoginModule } from "@mipro/nhs-login.module";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { LinkNhsMiproDialogComponent } from "@project/self-registration/ask-password/link-nhs-mipro-dialog.component";

@NgModule({
    declarations: [
        PlayersGridComponent,
        CreateSelfRegisterPlayerFormComponent,
        SelfRegisterPlayerComponent,
        EditPlayerComponent,
        EditPlayerTabsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        BbCardModule,
        FilterModule,
        PrimeNgModule,
        MiproSharedModule,
        PlayerRoutingModule,
        PlayerSharedModule,
        NgIdleKeepaliveModule,
        BbFormIOModule,
        NhsLoginModule,
        BbwtSharedModule,
        LinkNhsMiproDialogComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [FormEventsService],
    exports: [SelfRegisterPlayerComponent]
})
export class PlayerModule {}
